// =============================================================================
// Global
// =============================================================================

// Send Verification Token
// =============================================================================

export default function(data, type) {
  const tokenStr = {
    __RequestVerificationToken: $(
      'input[name=__RequestVerificationToken]'
    ).val()
  };
  data = $.extend(tokenStr, data);
  return data;
}
